import $ from 'jquery';

/**
 * LogTerminal.js 1.5
 * Window overlay log terminal
 * http://www.markuslerner.com
 * 2016-08-25
 *
 * 2015-01-08 (1.4)
 * 2014-11-20 (1.3)
 * 2014-09-11 (1.2)
 *
 * Copyright Markus Lerner
 * Free to use under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * required: jquery
 * sugguested: jquery.mCustomScrollbar.concat.min.js
 */


const LogTerminal = {
  buffer: [],
  count: 0,
  modified: false,
  defaults: {
    showLineNumbers: true,
    linesNumMax: 1000,
    consoleLog: true,
    width: '300px'
  },
  inited: false,
  div: null
};

LogTerminal.init = function(options = {}) {

  
};

LogTerminal.hide = function() {

};

export default LogTerminal;

export function log(text) {
  console.log(text);
};